<template>
  <div :class="componentClassName">
    <template v-for="(item, index) in currentSettingList" :key="index">
      <!-- 24時間チェックを非表示にするため、以下を一時的に削除
           v-model:is24hours="item.is24hours"
           @update:is24hours="handlePeriodChange"
       -->
      <m-business-hour-setting-item
        v-model="item.active"
        v-model:periods="item.periods"
        v-model:breakTimePeriods="item.breakTimePeriods"
        :item-index="item.itemIndex"
        :label="item.label"
        @change="handlePeriodChange"
        @add="handlePeriodChange"
        @remove="handlePeriodChange"
        @update:period="handlePeriodChange"
        @breakTimeChange="handleBreakTimePeriodChange"
        @breakTimeAdd="handleBreakTimePeriodChange"
        @breakTimeRemove="handleBreakTimePeriodChange"
        @update:breakTimePeriod="handleBreakTimePeriodChange"
      />
    </template>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import MBusinessHourSettingItem from '@/components/molecules/business-hour-setting-item';
import { cloneDeep } from 'lodash';

export default {
  name: 'o-business-hour-setting-list',
  components: {
    MBusinessHourSettingItem,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    modelValue: {
      type: Array,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      days: ['月', '火', '水', '木', '金', '土', '日'],
      currentSettingList: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('o-business-hour-setting-list');
      return `${baseClassName} ${this.class}`.trim();
    },
    dayList() {
      return this.days.map(day => `${day}曜日`);
    },
  },
  watch: {
    modelValue: {
      handler(val) {
        this.setCurrentValue(val);
      },
      deep: true,
    },
  },
  mounted() {
    this.currentSettingList.splice(0);
    this.days.forEach((day, index) => {
      this.currentSettingList.push({
        label: `${day}曜日`,
        active: false,
        periods: [],
        // 24時間チェックを非表示にし、「営業時間を追加」を活性化させるためfalseに固定
        is24hours: false,
        //休憩時間
        breakTimePeriods: [],
      });
    });
    if (this.modelValue) {
      this.setCurrentValue(this.modelValue);
    }
  },
  methods: {
    handlePeriodChange() {
      this.emitEvent();
    },
    handleBreakTimePeriodChange() {
      this.emitEvent();
    },
    emitEvent() {
      this.$emit('update:modelValue', cloneDeep(this.currentSettingList));
    },
    setCurrentValue(val) {
      this.currentSettingList.splice(0);
      this.days.forEach((day, index) => {
        this.currentSettingList.push({
          label: `${day}曜日`,
          active: false,
          periods: [],
          // 24時間チェックを非表示にし、「営業時間を追加」を活性化させるためfalseに固定
          is24hours: false,
          //休憩時間
          breakTimePeriods: [],
        });
      });
      val.forEach((item, index) => {
        if (index < this.days.length) {
          const day = this.days[index];
          this.currentSettingList[index].active = item.active || false;
          if (item.periods) {
            item.periods.forEach(period => {
              this.currentSettingList[index].periods.push(period);
            });
          }
          //休憩時間
          if (item.breakTimePeriods) {
            item.breakTimePeriods.forEach(breakTimePeriod => {
              this.currentSettingList[index].breakTimePeriods.push(breakTimePeriod);
            });
          }
          this.currentSettingList[index].is24hours = item.is24hours;
        }
      });
    },
  },
};
</script>
